export const globalServicesManager = {
  header: {
    title: "Services et expériences",
    description: "Une seule liste pour tout votre compte. Écrivez chaque service une fois et cochez dans quelles annonces il est proposé.",
  },

  toolbar: {
    info: "Ce que vous créez ici apparaît dans votre <strong>moteur de réservation</strong> et sur votre <strong>site</strong>, dans les annonces cochées.",
    newService: "Nouveau service",
  },

  loading: "Chargement des services…",

  empty: {
    title: "Pas encore de services",
    description: "Un transfert, une visite guidée, un panier de bienvenue… Le voyageur les ajoute en réservant.",
    create: "Créer le premier",
  },

  status: {
    active: "Actif",
    paused: "En pause",
  },

  price: {
    onRequest: "Sur demande",
    free: "Gratuit",
  },

  assign: {
    title: "Dans quelles annonces",
    listingsLabel: "Vos annonces",
    selectAll: "Tout sélectionner",
    clearAll: "Tout décocher",
    inAll: "Dans toutes les annonces",
    inSome: "Dans {n} sur {total}",
    units: "{n} unités",
    pickRooms: "Choisir les chambres",
    hideRooms: "Masquer les chambres",
    roomsHint: "Cochez uniquement les chambres où il est proposé. Si aucune n’est cochée, il l’est partout.",
    inRooms: "Dans 1 chambre | Dans {count} chambres",
    unassigned: "Non attribué",
    helperNone: "Si rien n’est coché, ce service n’est proposé NULLE PART.",
    roomsChecked: "1 cochée · effacer | {count} cochées · effacer",
    andMore: "+1 autre | +{count} autres",
    helper: "Sans rien cocher, le service est proposé dans toutes vos annonces.",
  },

  actions: {
    edit: "Modifier",
    delete: "Supprimer",
    cancel: "Annuler",
    save: "Enregistrer",
  },

  delete: {
    title: "Supprimer le service",
    text: "« {name} » ne sera plus proposé dans aucune annonce. Impossible de revenir en arrière.",
    accept: "Oui, supprimer",
  },

  saved: {
    assign: "Annonces mises à jour",
    state: "Service mis à jour",
    deleted: "Service supprimé",
  },

  errors: {
    load: "Nous n'avons pas pu charger vos services.",
    assign: "Nous n'avons pas pu enregistrer les annonces.",
    state: "Nous n'avons pas pu modifier le service.",
    delete: "Nous n'avons pas pu supprimer le service.",
  },
};
